import { checkEmailValidity, getEmailErrorMessage } from "../emailBlocking";

export const isEmailValid = (form) => {
    const email = form.vals().Email;
    const country = form.vals().Country;

    if (!email || !country) return;

    if (!checkEmailValidity(email.toLowerCase(), country)) {
        const emailInput = form.getFormElem().find("#Email");
        const emailErrorMessage = getEmailErrorMessage();

        form.showErrorMessage(emailErrorMessage, emailInput);

        form.submitable(false);
    } else {
        form.submitable(true);
    }
}